/* User-initiated playback for the native, editor-managed founder-film section. */
if (!customElements.get('moruga-film-player')) {
  customElements.define('moruga-film-player', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const details = this.querySelector('details');
      const summary = details?.querySelector('summary');
      const video = details?.querySelector('video');
      const status = this.querySelector('[data-film-status]');
      if (!details || !summary || !video) return;
      this.initialized = true;
      summary.addEventListener('click', () => {
        if (details.open) { video.pause(); return; }
        if (status) status.textContent = '';
        const playback = video.play();
        if (playback?.catch) playback.catch(() => {
          if (status) status.textContent = 'Bitte starte den Film über die Wiedergabetaste im Video.';
        });
      });
      details.addEventListener('toggle', () => {
        if (!details.open) video.pause();
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && details.open) {
          details.open = false;
          video.pause();
          summary.focus();
        }
      });
    }
    disconnectedCallback() { this.querySelector('video')?.pause(); }
  });
}
